export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Menú Principal',
            'SAMPLE'        : {
                'TITLE': 'DASHBOARD',
                'BADGE': '25'
            }
        }
    }
};
